import { useState } from 'react';

import { Mediator } from '@spotahome/soyuz-mediator';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_INFORMATION_MODAL, INFORMATION_MODAL_OPENED_MOBILE, CLOSE_INFORMATION_MODAL } from '../utils/constants';
import { isMobileScreen } from '../utils/breakpoints';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import styles from './InformationModal.module.scss';

const InformationModal = () => {
  const [stack, setStack] = useState([]);

  const handleOpen = ({ title, body, fullscreenOnMobile = false }) => {
    setStack(prev => [...prev, { title, body, fullscreenOnMobile }]);
    if (isMobileScreen()) {
      Mediator.publish(INFORMATION_MODAL_OPENED_MOBILE);
    }
  };

  const { handleModalClose } = useMediatorModalHandle({
    channel: OPEN_INFORMATION_MODAL,
    onOpen: handleOpen
  });

  const handleCloseAll = () => {
    setStack([]);
    handleModalClose();
    if (isMobileScreen()) {
      Mediator.publish(CLOSE_INFORMATION_MODAL);
    }
  };

  const handleBack = () => {
    setStack(prev => prev.slice(0, -1));
  };

  const currentItem = stack[stack.length - 1];
  const isOpen = stack.length > 0;
  const isBottomSheet = currentItem && !currentItem.fullscreenOnMobile;
  const showAsBottomSheet = isBottomSheet && isMobileScreen();
  const backgroundItems = showAsBottomSheet ? stack.slice(0, -1) : [];
  const handleCurrentClose = showAsBottomSheet && backgroundItems.length > 0 ? handleBack : handleCloseAll;

  return isOpen ? (
    <>
      {backgroundItems.map((item, i) => {
        const itemIsFullscreen = item.fullscreenOnMobile && isMobileScreen();
        return (
          <div key={i} className={styles['background-modal-overlay']}>
            <div className={[
              styles['information-modal'],
              itemIsFullscreen ? styles['background-modal-content--fullscreen'] : styles['background-modal-content']
            ].join(' ')}>
              <ModalHeader
                className={styles['information-modal__header']}
                label={item.title}
              />
              <ModalBody className={styles['information-modal__body']}>
                {item.body}
              </ModalBody>
            </div>
          </div>
        );
      })}
      <Modal
        isOpen={isOpen}
        onRequestClose={handleCurrentClose}
        size={
          currentItem.fullscreenOnMobile && isMobileScreen()
            ? 'fullscreen'
            : undefined
        }
        className={[
          styles['information-modal'],
          isBottomSheet && styles['information-modal--bottom-sheet']
        ].filter(Boolean).join(' ')}
        overlayClassName={isBottomSheet ? styles['information-modal__overlay--bottom-sheet'] : ''}
      >
        <ModalHeader
          className={styles['information-modal__header']}
          onRequestClose={handleCurrentClose}
          onRequestBack={handleBack}
          showBack={!showAsBottomSheet && stack.length > 1}
          label={currentItem.title}
        />
        <ModalBody className={styles['information-modal__body']}>
          {currentItem.body}
        </ModalBody>
      </Modal>
    </>
  ) : null;
};

export default InformationModal;
